import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import {store} from './store/store'
import auth from '../plugins/auth'

Vue.use(auth);

axios.interceptors.request.use(function (config) {
    var token = Vue.auth.getToken();
    if(token) {
        config.headers['Authorization']  ='Bearer ' + token;
    }
    return config;
}, function (error) {
    console.log(error);
});


new Vue({
    el: '#frontfilter',
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./vue/frontfilter/index.js